//@ts-nocheck
import React, { FC, useEffect, useCallback, useState, useMemo, MouseEvent } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TableWrapWithPagination from 'components/tables/TableWrapWithPagination';
import { formatDate } from 'helpers/formatters';
import useCompany, { useCompanyType } from 'hooks/api/useCompany';
import { typeAo } from 'components/forms/ActivationOrderForm/CardsAo/data';
import { AoTypeEnum } from 'hooks/api/useActivationOrder';
import downloadSvg from 'assets/img/download.svg';
import urls from 'constants/urls';

import Flex from 'components/Flex';
import styles from './styles.module.scss';
import endpoints from 'consts/endpoints';
import { getFileStorage } from '../../reportsData';
import { useUserContext } from 'contexts/UserProvider';
import { isAdmin } from 'helpers/token';

import s from './styles.module.scss';
import {
  AddIcon,
  Button,
  Checkbox,
  DoneIcon,
  DownloadIcon,
  PencilIcon,
  Select as UIKitSelect,
  Table,
  Tooltip,
  notification,
} from '@gamesb42/ui-kit';
import baseRequest from 'queries/baseRequest';
import { Dropdown, Menu } from 'antd';
import Status, { StatusEnumTitle } from 'components/common/Status';

import AOBulkActionModals from './AOBulkActionModals';
import {
  AO_BULK_SETTINGS,
  AO_STATUS_FILTER_OPTIONS,
  AO_TYPE_FILTER_OPTIONS,
  BulkAoActionT,
  MAX_BULK_SELECTION,
  fetchBulkAvailableActions,
  matchesAoFilters,
} from './bulkActions';

type PropsT = {
  companyId: string;
};

const AOClient: FC<PropsT> = ({ companyId }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { getAOByCompany, aOByCompanyData }: useCompanyType = useCompany();
  const [currentProductFilter, setCurrentProductFilter] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [documentStatus, setDocumentStatus] = useState('');
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [availableActions, setAvailableActions] = useState<BulkAoActionT[]>([]);
  const [isLoadingAvailableActions, setIsLoadingAvailableActions] = useState(false);
  const [selectedSettingKey, setSelectedSettingKey] = useState<string | undefined>(undefined);
  const [activeBulkAction, setActiveBulkAction] = useState<BulkAoActionT | null>(null);
  const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);
  const [typeFilters, setTypeFilters] = useState<string[]>([]);
  const [statusFilters, setStatusFilters] = useState<string[]>([]);
  const { logOut, user } = useUserContext();
  // Убираем локальную переменную isAdmin

  const columns = [
    {
      title: 'Name',
      width: '198px',
      align: 'left' as 'left',
      render: (row: any) => (
        <span
          onClick={() => history.push(`${urls.getActivationOrder()}/${row.id}`)}
          style={{ color: '#7145EC', textDecoration: 'underline', cursor: 'pointer' }}
        >
          {row.name}
        </span>
      ),
    },
    {
      title: 'Type',
      width: '196px',
      align: 'left' as 'left',
      render: (row: any) => <>{typeAo.find((type) => type.key === row.ao_type)?.name}</>,
    },
    {
      title: 'Signing',
      width: '159px',
      align: 'center' as 'center',
      render: (row: any) => {
        return row.files.length > 0 ? <Flex>{renderSigningStatus(row.files[0].status)}</Flex> : <></>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '211px',
      align: 'center' as 'center',
      render: (status: string) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Status style={{ width: '100%' }} status={status} />
          </div>
        );
      },
    },
    {
      title: '',
      dataIndex: '',
      align: 'left' as 'left',
      render: (row: any) => {
        return (
          <div style={{ display: 'flex', height: '100%', gap: '32px', alignItems: 'center' }}>
            <Tooltip title="Edit">
              <Button
                style={{
                  visibility: ['ACTIVE', 'NEW'].includes(row.status) ? 'visible' : 'hidden',
                }}
                type="iconBtn"
                size="middle"
                onClick={() => history.push(`${urls.getActivationOrder()}/edit/${row.ao_type}/${row.id}`)}
                icon={<PencilIcon />}
              />
            </Tooltip>
            {row.files[0]?.id && (
              <Tooltip title="Download">
                <Button
                  type="iconBtn"
                  icon={<DownloadIcon size={16} />}
                  size="middle"
                  onClick={(e: any) => downloadPdf(e, row.files[0]?.id)}
                />
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const setCompany = useCallback(() => {
    companyId && getAOByCompany({ company_id: companyId });
  }, [companyId, getAOByCompany]);

  useEffect(() => {
    setCompany();
  }, [setCompany]);

  const getPdf = (fileId?: string, openPdf: boolean = false) => {
    if (!fileId) return;
    getFileStorage(endpoints.getStorageFileUrl(fileId), undefined, undefined, undefined, openPdf);
  };

  const downloadPdf = (e: MouseEvent<HTMLImageElement>, fileId?: string) => {
    e.stopPropagation();
    getPdf(fileId);
  };

  const preparedAOByCompanyData = useMemo(() => {
    let rows = aOByCompanyData || [];

    if (currentProductFilter) {
      rows = rows.filter((ao) => ao.ao_type === currentProductFilter);
    }

    if (typeFilters.length > 0 || statusFilters.length > 0) {
      rows = rows.filter((ao) => matchesAoFilters(ao, typeFilters, statusFilters));
    }

    return rows;
  }, [aOByCompanyData, currentProductFilter, typeFilters, statusFilters]);

  const toggleBulkMode = useCallback(() => {
    setIsBulkMode((prev) => !prev);
    setSelectedRowKeys([]);
    setAvailableActions([]);
    setSelectedSettingKey(undefined);
    setActiveBulkAction(null);
  }, []);

  const handleBulkSuccess = useCallback(
    (message: string) => {
      notification.success({
        theme: 'dark',
        placement: 'bottomLeft',
        message,
      });
      setSelectedSettingKey(undefined);
      setActiveBulkAction(null);
      setCompany();
    },
    [setCompany],
  );

  const handleBulkError = useCallback((message: string) => {
    notification.error({
      theme: 'dark',
      placement: 'bottomLeft',
      message,
    });
  }, []);

  const handleModalClose = useCallback(() => {
    setActiveBulkAction(null);
    setSelectedSettingKey(undefined);
  }, []);

  const handleSelectionChange = useCallback(
    (keys: React.Key[]) => {
      if (keys.length > MAX_BULK_SELECTION) {
        notification.warning({
          theme: 'dark',
          placement: 'bottomLeft',
          message: t('forms.activationOrder.bulk.maxSelection', { count: MAX_BULK_SELECTION }),
        });
        return;
      }

      setSelectedRowKeys(keys as string[]);
    },
    [t],
  );

  const settingOptions = useMemo(
    () =>
      AO_BULK_SETTINGS.map(({ key, labelKey, action }) => {
        const isAvailable = Boolean(action && availableActions.includes(action));

        return {
          value: key,
          label: t(labelKey),
          disabled: selectedRowKeys.length === 0 || isLoadingAvailableActions || !isAvailable,
        };
      }),
    [availableActions, isLoadingAvailableActions, selectedRowKeys.length, t],
  );

  const hasNoAvailableActions =
    selectedRowKeys.length > 0 && !isLoadingAvailableActions && availableActions.length === 0;

  const handleSettingChange = useCallback((key: string) => {
    const setting = AO_BULK_SETTINGS.find((item) => item.key === key);

    if (!setting?.action) return;

    setSelectedSettingKey(key);
    setActiveBulkAction(setting.action);
  }, []);

  const isAllSelected =
    preparedAOByCompanyData.length > 0 && selectedRowKeys.length === preparedAOByCompanyData.length;

  const toggleSelectAll = useCallback(() => {
    if (isAllSelected) {
      setSelectedRowKeys([]);
      return;
    }

    if (preparedAOByCompanyData.length > MAX_BULK_SELECTION) {
      notification.warning({
        theme: 'dark',
        placement: 'bottomLeft',
        message: t('forms.activationOrder.bulk.maxSelection', { count: MAX_BULK_SELECTION }),
      });
    }

    setSelectedRowKeys(preparedAOByCompanyData.slice(0, MAX_BULK_SELECTION).map((row) => row.id));
  }, [isAllSelected, preparedAOByCompanyData, t]);

  useEffect(() => {
    if (!isBulkMode) return;

    const visibleIds = new Set(preparedAOByCompanyData.map((row) => row.id));

    setSelectedRowKeys((prev) => {
      const next = prev.filter((id) => visibleIds.has(id));

      return next.length === prev.length ? prev : next;
    });
  }, [preparedAOByCompanyData, isBulkMode]);

  useEffect(() => {
    if (!isBulkMode || selectedRowKeys.length === 0) {
      setAvailableActions([]);
      setSelectedSettingKey(undefined);
      setActiveBulkAction(null);
      return;
    }

    let isCancelled = false;

    setIsLoadingAvailableActions(true);
    fetchBulkAvailableActions(companyId, selectedRowKeys)
      .then((response) => {
        if (isCancelled) return;

        const nextActions = response.available_actions || [];
        setAvailableActions(nextActions);
        setSelectedSettingKey((prev) => {
          const prevAction = AO_BULK_SETTINGS.find((setting) => setting.key === prev)?.action;

          if (prevAction && nextActions.includes(prevAction)) return prev;

          setActiveBulkAction(null);
          return undefined;
        });
      })
      .catch(() => {
        if (isCancelled) return;

        setAvailableActions([]);
        setSelectedSettingKey(undefined);
        setActiveBulkAction(null);
        notification.error({
          theme: 'dark',
          placement: 'bottomLeft',
          message: t('forms.activationOrder.bulk.availableError'),
        });
      })
      .finally(() => {
        if (!isCancelled) setIsLoadingAvailableActions(false);
      });

    return () => {
      isCancelled = true;
    };
  }, [companyId, isBulkMode, selectedRowKeys, t]);

  useEffect(() => {
    if (preparedAOByCompanyData.length > 0) {
      const fetchDocumentStatus = async () => {
        try {
          const result = await baseRequest({
            path: `${process.env.REACT_APP_BASE_URL}/activation_order/${preparedAOByCompanyData[0]?.id}/status`,
            options: {
              method: 'GET',
            },
          });
          setDocumentStatus(result.document_status);
        } catch (error) {
          console.error('Ошибка при получении статуса документа:', error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchDocumentStatus();
    }
  }, [preparedAOByCompanyData]);

  function renderSigningStatus(status: string) {
    switch (status) {
      case 'sent':
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '24px',
              borderRadius: '4px',
              background: '#9FA5B9',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            SENT
          </div>
        );
      case 'created':
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '24px',
              borderRadius: '4px',
              background: '#95B3FF',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            CREATED
          </div>
        );
      case 'signed':
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '24px',
              borderRadius: '4px',
              background: '#95B3FF',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            SIGNED BY CLIENT
          </div>
        );
      case 'delivered':
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '24px',
              borderRadius: '4px',
              background: '#95B3FF',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            DELIVERED
          </div>
        );
      case 'completed':
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '24px',
              borderRadius: '4px',
              background: '#32D141',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            COMPLETED
          </div>
        );
      default:
        return <></>;
    }
  }

  function renderCreateAO() {
    return (
      <Menu className={s.noFilesMenu}>
        <Menu.Item
          key="1"
          className={s.noFilesMenuItem}
          onClick={() => history.push(`${urls.getActivationOrderCreateLink()}/available_receivables/${companyId}`)}
        >
          NOW
        </Menu.Item>
        <Menu.Item
          key="2"
          className={s.noFilesMenuItem}
          onClick={() => history.push(`${urls.getActivationOrderCreateLink()}/classic/${companyId}`)}
        >
          CLASSIC
        </Menu.Item>
        <Menu.Item
          key="3"
          className={s.noFilesMenuItem}
          onClick={() => history.push(`${urls.getActivationOrderCreateLink()}/future/${companyId}`)}
        >
          FUTURE
        </Menu.Item>
      </Menu>
    );
  }

  return (
    <div className={styles.wrapper}>
      {isAdmin() && preparedAOByCompanyData.length === 0 && (
        <div className={s.noFiles}>
          <div>There are no files yet</div>
          <Dropdown overlay={renderCreateAO} trigger={['click']}>
            <Button style={{ backgroundColor: '#9197AD', color: '#fff', border: 'none' }} icon={<AddIcon size={16} />}>
              Create AO
            </Button>
          </Dropdown>
        </div>
      )}
      <div>
        {isAdmin() && aOByCompanyData?.length > 0 && (
          <>
            <div className={styles.toolbar}>
              <div className={styles.toolbarLeft}>
                <UIKitSelect
                  mode="multiple"
                  allowClear
                  label={t('forms.activationOrder.bulk.filterType')}
                  value={typeFilters}
                  width="220px"
                  options={AO_TYPE_FILTER_OPTIONS.map(({ key, legacyTypes }) => ({
                    label: typeAo.find((type) => type.key === legacyTypes[0])?.name || key,
                    value: key,
                  }))}
                  onChange={setTypeFilters}
                />
                <UIKitSelect
                  mode="multiple"
                  allowClear
                  label={t('forms.activationOrder.bulk.filterStatus')}
                  value={statusFilters}
                  width="260px"
                  options={AO_STATUS_FILTER_OPTIONS.map((status) => ({ label: status, value: status }))}
                  onChange={setStatusFilters}
                />
              </div>
              <div className={styles.toolbarRight}>
                <Button icon={<DoneIcon size={16} />} onClick={toggleBulkMode}>
                  {t('forms.activationOrder.bulk.applySettings')}
                </Button>
                <Dropdown overlay={renderCreateAO} trigger={['click']}>
                  <Button
                    style={{ backgroundColor: '#9197AD', color: '#fff', border: 'none' }}
                    icon={<AddIcon size={16} />}
                  >
                    Create AO
                  </Button>
                </Dropdown>
              </div>
            </div>
            {isBulkMode && (
              <div className={styles.bulkBar}>
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={selectedRowKeys.length > 0 && !isAllSelected}
                  onChange={toggleSelectAll}
                >
                  {t('forms.activationOrder.bulk.selectAll')}
                </Checkbox>
                <UIKitSelect
                  className={styles.settingSelect}
                  label={t('forms.activationOrder.bulk.selectSetting')}
                  value={selectedSettingKey}
                  loading={isLoadingAvailableActions}
                  options={settingOptions}
                  listHeight={AO_BULK_SETTINGS.length * 40}
                  onChange={handleSettingChange}
                />
              </div>
            )}
            {isBulkMode && hasNoAvailableActions && (
              <div className={styles.bulkHint}>{t('forms.activationOrder.bulk.noAvailableActions')}</div>
            )}
          </>
        )}
        <Table
          className={styles.table}
          rowKey="id"
          columns={columns}
          dataSource={preparedAOByCompanyData}
          loading={isLoading}
          rowSelection={
            isBulkMode
              ? {
                  selectedRowKeys,
                  hideSelectAll: true,
                  onChange: handleSelectionChange,
                }
              : undefined
          }
        />
      </div>
      <AOBulkActionModals
        companyId={companyId}
        orderIds={selectedRowKeys}
        activeAction={activeBulkAction}
        title={settingOptions.find(({ value }) => value === selectedSettingKey)?.label || ''}
        isSubmitting={isBulkSubmitting}
        onClose={handleModalClose}
        onSubmittingChange={setIsBulkSubmitting}
        onSuccess={handleBulkSuccess}
        onError={handleBulkError}
      />
    </div>
  );
};

export default AOClient;
